import moment from 'moment-timezone';

export const convertDateFormat = (inputDate) => {
    const dateObj = moment.utc(inputDate);
    const newYorkDate = dateObj.tz('America/New_York');
    
    return `${newYorkDate.format('MMM DD, YYYY')}`;
};

export const extractTimeFromTimestamp = (timestamp) => {
    const dateObj = moment.utc(timestamp);
    const newYorkTime = dateObj.tz('America/New_York');
    const utcOffset = newYorkTime.format('Z'); // Get the UTC offset in the format +05:00 or -05:00

    return `${newYorkTime.format('HH:mm:ss')} ET (UTC${utcOffset})`;
};
